<template>
  <form @submit.prevent="saveAddress">
    <div class="dialog-header">
      <h1>{{ custom.project.label ? custom.project.label : 'Project' }}</h1>
      <input
        v-if="projects.length > 7"
        v-model="projectFilter"
        type="text"
        placeholder="Zoek project..."
        class="project-filter grey-field"
      />
    </div>
    <div class="dialog-content" :style="topPadding">
      <form
        class="inp-container"
        @submit.prevent="saveProject"
        v-if="!custom.project.hideNewProject"
      >
        <project-input
          :fields="custom.project.fields"
          :hyphen="custom.project.hyphen"
          :prefix="custom.project.prefix"
          @setProject="storeNewProject"
          @add-error="error = true"
          @remove-error="error = false"
          :project-name="newProjectName"
          class="input"
        ></project-input>
        <button
          class="pill-button add-button"
          type="submit"
          title="Project"
          :disabled="!newProjectName"
        >
          Voeg toe
        </button>
      </form>
      <div class="list">
        <ul>
          <li
            v-for="project in filteredProjects"
            :key="project.id"
            @click="selectProject({ name: project.name, id: project.id })"
            :class="{ active: project === activeProject }"
          >
            <span>
              {{ project.name || project.value }}
            </span>
            <remove-button
              v-if="project.userId"
              @click.native="removeProject(project)"
            ></remove-button>
          </li>
        </ul>
      </div>
    </div>
  </form>
</template>

<script>
import ProjectInput from '@/components/ProjectInput'
import RemoveButton from '@/components/ui/RemoveButton.vue'
import { saveProject, deleteProject } from '@/api/addressBookApi'
import { useAddressBookStore } from '@/stores/AddressBook.store'

export default {
  props: {
    customerNumber: Number,
    setProject: Function
  },
  components: {
    ProjectInput,
    RemoveButton
  },
  data() {
    return {
      newProjectName: '',
      error: false,
      projectFilter: ''
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    invoiceAddresses() {
      const addressBook = useAddressBookStore()
      return addressBook.invoiceAddresses
    },
    projectRequired() {
      return !!(
        this.custom.project.required || this.rootStore.user.projectRequired
      )
    },
    activeProject() {
      return ''
    },
    projects() {
      const address = this.invoiceAddresses.find(
        (address) => address.customerNumber === this.customerNumber
      )
      return address.projects || []
    },
    filteredProjects() {
      const list = !this.projectFilter
        ? [...this.projects]
        : (() => {
            const filter = this.projectFilter.toLowerCase()
            return this.projects.filter((p) =>
              (p.name || p.value || '').toLowerCase().includes(filter)
            )
          })()
      return list.sort((a, b) =>
        (a.name || a.value || '').localeCompare(b.name || b.value || '', 'nl', {
          numeric: true,
          sensitivity: 'base'
        })
      )
    },
    topPadding() {
      if (this.custom.project.hideNewProject) {
        return { 'padding-top': '10px' }
      }
    }
  },
  methods: {
    storeNewProject(val) {
      this.newProjectName = val
    },
    saveProject() {
      if (!this.newProjectName || this.error) {
        return
      }

      saveProject(this.customerNumber, { name: this.newProjectName }).then(
        (project) => {
          const addressBook = useAddressBookStore()
          addressBook.addAddressProject(project)

          this.selectProject({ name: project.name, id: project.id })
        }
      )
    },
    selectProject(project) {
      this.setProject(project)
      this.$emit('close')
    },
    removeProject(project) {
      deleteProject(project).then(() => {
        const addressBook = useAddressBookStore()
        addressBook.deleteAddressProject(project)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  align-items: center;
  align-items: baseline;

  h1 {
    flex-grow: 1;
  }
}

.list {
  overflow-y: auto;
  height: 400px;
  position: relative;

  &::after {
    content: '';
    position: sticky;
    bottom: 0;
    display: block;
    height: 40px;
    background: linear-gradient(to bottom, transparent, white);
    pointer-events: none;
  }
}
.inp-container {
  display: flex;
  align-items: center;

  .input {
    flex-grow: 1;
  }

  .add-button {
    margin-bottom: 10px;
    margin-left: 10px;
  }

  /*  button {
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    margin: 7px 0 0 7px;
  }*/

  svg {
    width: 100%;
    height: 100%;

    :deep(circle) {
      fill: var(--sub-color);
    }
  }
}

li {
  padding: 10px 5px;
  text-align: left;
  border-radius: 20px;
  transition: 0.4s all;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    //    box-shadow: var(--default-shadow);
    font-weight: 600;
  }

  &.active {
    font-weight: 500;
  }

  span {
    flex-grow: 1;
  }

  button {
  }
}
</style>
